import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FormHelperText } from "@mui/material";
import Link from "@mui/material/Link";
import makeStyles from "@mui/styles/makeStyles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Button from "@mui/material/Button";
import LoadingButton from "../../../components/LoadingButton";
import BoxActions from "./BoxActions";
import { useAuth } from "../../providers/AuthProvider";
import FormikTextField from "../../../components/Common/FormikTextField";
import Level2BoxContainer from "./Level2BoxContainer";
import { Level2BoxHeading } from "./Level2BoxHeading";
import ForgotPasswordDialog from "../../Mobile/Components/ForgotPasswordDialog";
const useStyles = makeStyles(() => ({
    form: {
        flexGrow: 1,
    },
    button: {
        flexBasis: "100px",
        flexShrink: 0,
        paddingLeft: 0,
        paddingRight: 0,
        flexGrow: 1,
    },
}));
const LoginExistingUser = ({ handleGoBack, handleLoginSuccess, }) => {
    const { t } = useTranslation();
    const { isAuthenticating, loginError, login: authLogin } = useAuth();
    const classes = useStyles();
    const [forgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useState();
    const openSendForgotPasswordDialog = (e) => {
        e.preventDefault();
        setForgotPasswordDialogOpen(true);
    };
    return (React.createElement(Level2BoxContainer, null,
        React.createElement(Level2BoxHeading, { color: "primary" },
            React.createElement(Trans, null, "Sign in")),
        React.createElement(Formik, { initialValues: { username: "", password: "" }, validationSchema: loginSchema(t), onSubmit: (values, { setValues }) => {
                // Trim spaces from username:
                setValues(Object.assign(Object.assign({}, values), { username: values.username.trim() }));
                authLogin(values.username.trim(), values.password)
                    .then((result) => {
                    handleLoginSuccess(result);
                })
                    .catch(() => { });
            } }, ({ submitForm, isValid, values }) => {
            return (React.createElement(Form, { className: classes.form },
                React.createElement(Field, { id: "login-email-address", component: FormikTextField, label: t("Email address"), name: "username", variant: "outlined", autoFocus: true, fullWidth: true }),
                React.createElement(Field, { id: "login-password", component: FormikTextField, type: "password", label: t("Password"), name: "password", variant: "outlined", fullWidth: true }),
                React.createElement(FormHelperText, { error: !!loginError }, loginError),
                React.createElement("p", null,
                    React.createElement(Trans, null, "Forgot your password?"),
                    " ",
                    React.createElement(Link, { onClick: openSendForgotPasswordDialog },
                        React.createElement(Trans, null, "Click here"))),
                React.createElement(BoxActions, null,
                    React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleGoBack, className: classes.button },
                        React.createElement(Trans, null, "Back")),
                    React.createElement(LoadingButton, { variant: "primary", isLoading: isAuthenticating, onClick: submitForm, disabled: !isValid, className: classes.button, "data-testid": "login-submit" },
                        React.createElement(Trans, null, "Sign in"))),
                forgotPasswordDialogOpen && (React.createElement(ForgotPasswordDialog, { email: values.username, onClose: () => setForgotPasswordDialogOpen(false) }))));
        })));
};
const loginSchema = (t) => () => {
    return Yup.object().shape({
        // Reject blank input without requiring email syntax: existing accounts
        // can also sign in with a non-email username.
        username: Yup.string().trim().required(t("This is required!")),
        password: Yup.string()
            .min(3, t("That's too short!"))
            .required(t("This is required!")),
    });
};
export default LoginExistingUser;
